var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_vm._t("label",function(){return [(_vm.label)?_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))]):_vm._e()]}),_c('div',{staticClass:"text-sm"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }